import _ from 'lodash';
import React from 'react';
import Button from 'react-bootstrap/Button';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import { Navigate, useLocation } from 'react-router-dom';
import animationData from '../../components/load/qr-code.json';
import { usePageview } from '../../hooks/use-pageview';
import { layoutDefaults } from '../../utils/layout-defaults';

function useQuery() {
  return new URLSearchParams(useLocation().search).get('e');
}

function RedirectOldScreen() {
  // const { analyticsPageView } = useAnalytics();
  const { t } = useTranslation();
  const query = useQuery();
  const classes = useStyles();

  // useEffect(() => {
  //     if (query != null) {

  //     }
  // }, [query]);

  usePageview('Root');

  // <Redirect to={"/" + query} />
  return !_.isEmpty(query) ? (
    <Navigate to={`/${query}`} />
  ) : (
    <div className={classes.container}>
      <FadeIn>
        <Lottie
          play
          animationData={animationData}
          style={{ width: 400, height: 400 }}
        />
        <div className={classes.text}>{t('redirect-old.text')}</div>

        <div className={classes.site}>
          {t('redirect-old.site')}
          <br />
          <Button
            variant="link"
            href="https://www.menur.app"
            className={classes.link}
          >
            {t('redirect-old.button')}
          </Button>
          {/* <a href="https://www.menur.app">www.menur.app</a> */}
        </div>
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    color: 'white',
    position: 'absolute',
    flexDirection: 'column',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: -70,
    // border: '1px solid yellow',
  },
  text: {
    marginTop: -50,
    alignContent: 'center',
    textAlign: 'center',
    // border: '1px solid red',
  },

  link: {
    cursor: 'pointer',
    // marginTop: 30,
    // alignContent: "center",
    // textAlign: "center",

    fontSize: layoutDefaults.bigFontSize,
    // fontSize: layoutDefaults.bigFontSize,
    // color: ({ value, isOpen }) => (!_.isEmpty(value) && isOpen) ? layoutDefaults.destructiveColor : layoutDefaults.linkColor,
    color: layoutDefaults.secondaryColor,
    padding: 0,
    // paddingRight: layoutDefaults.horizontalMargin * 2,
    // border: "1px solid green",

    // zIndex: 1,
  },

  site: {
    marginTop: 30,
    alignContent: 'center',
    textAlign: 'center',
    fontSize: layoutDefaults.bigFontSize,

    // color: layoutDefaults.primaryColor,
    // border: '1px solid red',
  },
});

export { RedirectOldScreen };
